import type { ClassName } from '@frontend/web-utils';
import { applyClass, concatClasses } from '@frontend/web-utils';
import { Card } from '../Card';

type ContainerProps = {
  children: Children;
  className?: ClassName;
  noPadding?: boolean;
  onClick?: () => void;
};

export const CardContainer = ({ children, className, noPadding, onClick }: ContainerProps) => (
  <Card
    className={concatClasses(
      'border-borderPrimary border-1 rounded-lg p-md bg-trueWhite',
      applyClass(noPadding, 'p-none'),
      className,
    )}
    onClick={onClick}
  >
    {children}
  </Card>
);
